<template>
  <div id="create-account" class="page">
    <!-- navbar component -->
    <Navbar />
    <div class="container">
      <div class="row">
        <!-- trading account info -->
        <div class="col-xl-3 col-lg-4">
          <div class="account-info mb-lg-0 mb-3">
            <div class="w-100 header-info">
              <h4
                class="text-center m-0 txt-title fs-md-5 fs-6"
                v-if="getLang == 'indo'"
              >
                {{ commonUI.accountInfo.title.indo }}
              </h4>
              <h4
                class="text-center m-0 txt-title fs-md-5 fs-6"
                v-if="getLang == 'uk'"
              >
                {{ commonUI.accountInfo.title.uk }}
              </h4>
            </div>
            <div
              class="content-info fs-md-5"
              v-for="item in dataAccount"
              :key="item._id"
            >
              <p v-if="getLang == 'indo'">{{ commonUI.accountInfo.name.indo }} : {{ item.name }}</p>
              <p v-if="getLang == 'uk'">{{ commonUI.accountInfo.name.uk }} : {{ item.name }}</p>
              <p v-if="getLang == 'indo'">{{ commonUI.accountInfo.email.indo }} : {{ item.email }}</p>
              <p v-if="getLang == 'uk'">{{ commonUI.accountInfo.email.uk }} : {{ item.email }}</p>
              <p v-if="getLang == 'indo'">{{ commonUI.accountInfo.type.indo }} : REAL</p>
              <p v-if="getLang == 'uk'">{{ commonUI.accountInfo.type.uk }} : REAL</p>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-8 text-lg-left text-center">
          <h1 class="txt-title fs-md-3 fs-4 mb-3" v-if="getLang == 'indo'">
            {{ config.ui.title.indo }}
          </h1>
          <h1 class="txt-title fs-md-3 fs-4 mb-3" v-if="getLang == 'uk'">
            {{ config.ui.title.uk }}
          </h1>
          <p class="fs-md-5 fs-6 mb-4" v-if="getLang == 'indo'">
            {{ config.ui.description.indo }}
          </p>
          <p class="fs-md-5 fs-6 mb-4" v-if="getLang == 'uk'">
            {{ config.ui.description.uk }}
          </p>
          <!-- choose card -->
          <div class="choose-card">
            <h3 class="txt-bold fs-md-5 fs-6" v-if="getLang == 'indo'">
              {{ config.ui.specification.indo }}
            </h3>
            <h3 class="txt-bold fs-md-5 fs-6" v-if="getLang == 'uk'">
              {{ config.ui.specification.uk }}
            </h3>
            <p class="fs-md-5 fs-6" v-if="getLang == 'indo'">
              {{ config.ui.chooseCard.indo }}
            </p>
            <p class="fs-md-5 fs-6" v-if="getLang == 'uk'">
              {{ config.ui.chooseCard.uk }}
            </p>
            <!-- cards spec -->
            <div class="cards-specs">
              <VueSlickCarousel v-bind="setting" class="vueSlick">
                <div v-for="(accountType, key) in config.accountTypes" :key="key">
                  <div
                    :for="`account-${accountType.key}`"
                    v-bind:class="{
                      card: true,
                      pointer: true,
                      selected: selectedAccount === accountType.key,
                    }"
                    v-on:click="updateCard(accountType.key)"
                  >
                    <h4 class="card-title txt-bold fs-md-4 fs-5">
                      {{ accountType.name }}
                    </h4>
                    <div class="list-spec">
                      <p v-if="Array.isArray(accountType.specs.spread)">Spread:</p>
                      <p v-for="spread in Array.isArray(accountType.specs.spread) ? accountType.specs.spread : [accountType.specs.spread]" :key="spread">{{ spread }}</p>
                      <p>{{ accountType.specs.commission }}</p>
                      <p>{{ accountType.specs.swap }}</p>
                    </div>
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
            <div class="mx-lg-0 mx-auto mt-xl-4 mt-5 pick-leverage">
              <div class="mx-auto select-custom mb-3 col-md-4 col-12 p-0">
                <select
                  class="w-100"
                  v-model="leverage"
                  name="select-account"
                  id="select-account"
                  required
                >
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                    v-if="getLang == 'indo'"
                  >
                    {{ config.ui.selectOption.indo }}
                  </option>
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                    v-if="getLang == 'uk'"
                  >
                    {{ config.ui.selectOption.uk }}
                  </option>
                  <option
                    v-for="option in config.leverageOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
                <span></span>
              </div>
            </div>
            <!-- button create account -->
            <button
              class="btn btn-blue txt-bold mt-5 mt-lg-4"
              @click="onCreateAccount"
              v-if="getLang == 'indo'"
            >
              {{ config.ui.createButton.indo }}
            </button>
            <button
              class="btn btn-blue txt-bold mt-5 mt-lg-4"
              @click="onCreateAccount"
              v-if="getLang == 'uk'"
            >
              {{ config.ui.createButton.uk }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "../components/Navbar.vue";
import axios from "axios";
import Swal from "sweetalert2";
import Notiflix from "notiflix";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { AppConstants, Languages, AccountTypes, ApiConfig, Messages, CommonUI } from "../const";

const userData = JSON.parse(localStorage.getItem("userData"));

export default {
  name: "createAccount",
  components: {
    Navbar,
    VueSlickCarousel,
  },
  data() {
    return {
      dataAccount: [],
      selectedAccount: null,
      spec_id: null,
      getLang: localStorage.getItem("setLang"),
      leverage: 200,
      config: AppConstants.realAccounts,
      commonUI: CommonUI,
      setting: {
        dots: true,
        slidesToShow: 3,
        infinite: false,
        speed: 500,
        initialSlide: 0,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  mounted() {
    Notiflix.Loading.init({
      className: "notiflix-loading",
      zindex: 4000,
      backgroundColor: "rgba(0,0,0,0.8)",
      rtl: false,
      useGoogleFont: false,
      fontFamily: "Quicksand",
      cssAnimation: true,
      cssAnimationDuration: 400,
      clickToClose: false,
      customSvgUrl: null,
      svgSize: "80px",
      svgColor: "#c09a07",
      messageID: "NotiflixLoadingMessage",
      messageFontSize: "15px",
      messageMaxLength: 34,
      messageColor: "#dcdcdc",
    });
    window.scrollTo(0, 0);

    // Initialize first account as selected
    const firstAccountKey = Object.keys(this.config.accountTypes)[0];
    if (firstAccountKey) {
      this.selectedAccount = firstAccountKey;
      this.spec_id = this.config.accountTypes[firstAccountKey].id;
    }

    let self = this;
    var configget = {
      method: "get",
      url: `${ApiConfig.url}/me`,
      headers: {
        "content-type": "application/json",
        "x-app-token": ApiConfig.token,
        "x-user-token": userData.token,
      },
    };

    axios(configget)
      .then(function (res) {
        let obj = res.data.data;
        self.dataAccount = [obj];
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    updateCard: function (accountKey) {
      this.selectedAccount = accountKey;
      if (this.config.accountTypes[accountKey]) {
        this.spec_id = this.config.accountTypes[accountKey].id;
      }
    },
    onCreateAccount: function () {
      Notiflix.Loading.circle({
        className: "notiflix-loading",
        svgColor: "#c09a07",
      });
      var data = {
        user_id: userData.user._id,
        spec_id: this.spec_id,
        leverage: this.leverage,
        type: AccountTypes.REAL,
      };

      var config = {
        method: "post",
        url: `${ApiConfig.url}/account`,
        headers: {
          "content-type": "application/json",
          "x-app-token": ApiConfig.token,
          "x-user-token": userData.token,
        },
        data: data,
      };

      if (this.getLang == Languages.INDO) {
        axios(config)
          .then(function () {
            Notiflix.Loading.remove();
            window.location.href = "/dashboard";
            Swal.fire({
              icon: "success",
              title: Messages.success.indo.title,
              text: Messages.success.indo.text,
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .catch(function (error) {
            Notiflix.Loading.remove();
            const message = error.response.data.message;
            if (
              message ==
              'Cast to ObjectId failed for value "null" at path "_id" for model "Account_spec"'
            ) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: Messages.error.serviceUnavailable.indo,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: `${message}`,
              });
            }
          });
      } else {
        axios(config)
          .then(function () {
            Notiflix.Loading.remove();
            window.location.href = "/dashboard";
            Swal.fire({
              icon: "success",
              title: Messages.success.uk.title,
              text: Messages.success.uk.text,
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .catch(function (error) {
            Notiflix.Loading.remove();
            const message = error.response.data.message;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `${message}`,
            });
          });
      }
    },
  },
};
</script>